import { RootState } from 'handlers';

export const getCreditReportData = ({ creditReport }: RootState) => creditReport;
